module.exports = __webpack_public_path__ + "img/step-4.b2d1517c.png";